import { action, computed, makeObservable, observable } from 'mobx'
import { getError, getValue, isPending } from 'mobx-async'

import { FeeCalculationType } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { getBookingFeeCatalog } from './api/addBookingFeeArriere'

export class _AddBookingFeeStore {
  private reloadToken = 0

  constructor() {
    makeObservable<_AddBookingFeeStore, 'feeCatalogPromise' | 'reloadToken'>(this, {
      reloadToken: observable,
      feeCatalogPromise: computed({ keepAlive: true }),
      feeCatalog: computed,
      discountFeeIds: computed,
      isLoadingFeeCatalog: computed,
      feeCatalogError: computed,
      reload: action.bound,
    })
  }

  private get feeCatalogPromise() {
    void this.reloadToken
    return getBookingFeeCatalog()
  }

  get feeCatalog() {
    return getValue(this.feeCatalogPromise) ?? []
  }

  get discountFeeIds() {
    return new Set(
      this.feeCatalog
        .filter(fee => fee.feeCalculationType === FeeCalculationType.discount)
        .map(fee => fee.id),
    )
  }

  get isLoadingFeeCatalog() {
    return isPending(this.feeCatalogPromise)
  }

  get feeCatalogError() {
    return getError(this.feeCatalogPromise)
  }

  reload() {
    this.reloadToken += 1
  }
}

export const addBookingFeeStore = new _AddBookingFeeStore()
